module.exports = __webpack_public_path__ + "static/media/WEBnegro_57.08309888.png";